import React from 'react';
import { Typography, Row, Col } from 'antd';
import { motion } from 'framer-motion';
import { standardVariants, containerVariants } from '../../utils/useAnimations';
import { AccessibleButton } from '../../components/AccessibleButton';
import { AccessibleImage } from '../../components/AccessibleImage';

const { Title, Paragraph } = Typography;

export const InfoSection: React.FC = () => {
  return (
    <section 
      className="max-w-[1440px] mx-auto px-20 pt-20 pb-12"
      aria-labelledby="info-title"
      role="region"
    > 
      <motion.div
        variants={standardVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
      >
        <Title 
          id="info-title"
          level={2} 
          className="!text-4xl !font-bold !text-center !mb-10"
        >
          Garantir l'accès à l'information
        </Title>
      </motion.div>
       
      <motion.div
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-50px" }}
      >
        <Row gutter={[80, 80]} align="middle">
          <Col xs={24} lg={12}>
            <motion.div 
              className="flex items-center justify-center"
              variants={standardVariants}
            >
              <AccessibleImage 
                src="/img/svg/alternatives.svg" 
                altKey="images.alternativesIllustration"
              />
            </motion.div>
          </Col>
          <Col xs={24} lg={12}>
            <motion.div variants={standardVariants}>
              <Paragraph className="text-lg">
                Cette interface n'est <b>pour le moment pas accessible à toutes les personnes en situation de handicap</b> et nous nous en excusons.
              </Paragraph>
              <Paragraph className="text-lg">
                Ce projet a pour but de <b>sensibiliser, en premier lieu, les personnes à priori "non-concernées" par le handicap</b>, aux différentes barrières que l'on peut trouver en ligne.
              </Paragraph>
              <Paragraph className="text-lg">
                Pour cette raison, nous avons préféré sortir <b>une première version de l'interface non-optimisée pour les lecteurs d'écran</b>, afin de commencer plus rapidement la sensibilisation du public.
              </Paragraph>
              <Paragraph className="text-lg">
                Cependant afin de permettre à tous de profiter de ce contenu, nous avons mis à disposition <b>un document (Google docs) disponible au téléchargement via Google Drive</b>, décrivant les différents parcours initiatiques proposés.
              </Paragraph>
              <Paragraph className="text-lg">
                Ouverture du lien dans un nouvel onglet.
              </Paragraph>
              
              <AccessibleButton 
                ariaLabelKey="buttons.accessDocument"
                href="https://docs.google.com/document/d/14kkFRZxzoA2GfJ5s5gtJYiJYn7vwdCfiNl_Kr6jCcOQ/edit?usp=sharing"
                isLink={true}
                target="_blank"
              > 
                Accéder au document (8ko)
              </AccessibleButton>
            </motion.div>
          </Col>
        </Row>
      </motion.div>
    </section>
  );
};